export const preparePostData = (entities) => {
    let periodsData = [];
    let stagesData = [];
    let stageCriteriasData = [];
    let statusIndicationsData = [];

    //Associated data must be handled first because of potentially
    //delete id action in periods and stages
    for (let i = 0; i < entities.statusIndications.length; i++) {
        var p = entities.statusIndications[i];
        let myPeriod = entities.periods.filter(x => x.id == p.periodId)[0];
        if (myPeriod) {
            if (myPeriod.isVirtualId) {
                p.tempPeriodId = myPeriod.id;
                p.periodIdIsVirtual = true;
                p.evaluationPeriodId = null;
            } else {
                p.evaluationPeriodId = myPeriod.id;
            }
        }

        if (p.isVirtualId) {
            delete p.id;
        }
        statusIndicationsData.push(p);
    }


    for (let i = 0; i < entities.stageCriterias.length; i++) {
        var p = entities.stageCriterias[i];
        let myStage = entities.stages.filter(x => x.id == p.stageId)[0];
        if (myStage) {
            if (myStage.isVirtualId) {
                p.tempStageId = myStage.id;
                p.stageIdIsVirtual = true;
                p.evaluationStageId = null;
            } else {
                p.evaluationStageId = myStage.id;
            }
        }

        if (p.isVirtualId) {
            delete p.id;
        }
        stageCriteriasData.push(p);
    }

    //main entities handling
    for (let i = 0; i < entities.periods.length; i++) {
        var p = entities.periods[i];
        let myStage = entities.stages.filter(x => x.id == p.stageId)[0];
        if (myStage) {
            if (myStage.isVirtualId) {
                p.tempStageId = myStage.id;
                p.stageIdIsVirtual = true;
                p.evaluationStageId = null;
            } else {
                p.evaluationStageId = myStage.id;
            }
        }

        if (p.isVirtualId) {
            delete p.id;
        }
        periodsData.push(p);
    }

    for (let i = 0; i < entities.stages.length; i++) {
        var s = entities.stages[i];
        if (s.isVirtualId) {
            delete s.id;
        }

        stagesData.push(s);
    }

    return {
        evaluationScheme: entities.scheme,
        evaluationPeriods: periodsData,
        evaluationStages: stagesData,
        evaluationStageCriterias: stageCriteriasData,
        evaluationStatusIndications: statusIndicationsData
    };

}

export const handleResultData = (result, copyFields = []) => {
    //Adicionando a o campo 'key' pra permitir a renderização da tabela sem erros
    //Adicionando a o campo 'index' pra permitir a ordenação da tabela (caso necessário)
    if (typeof (result) !== 'undefined' && result.length > 0) {
        for (var i = 0; i < result.length; i++) {
            result[i].key = i +1;
            result[i].index = i;
            if (copyFields.length > 0) {
                for (var j = 0; j < copyFields.length; j++) {
                    var { origin, target } = copyFields[j];
                    if (result[i][origin]) {
                        result[i][target] = result[i][origin];
                    }
                }
            }
        }
    }
    return result;
}
const schemesFunctions = {
    preparePostData,
    handleResultData
}

export default schemesFunctions;